module.exports = __webpack_public_path__ + "img/flecha-aqui.6bf5aaa6.svg";